const Form = require('./components/Form');
const FormField = require('./components/FormField');
const FormButton = require('./components/FormButton');
const FormCheckbox = require('./components/FormCheckbox');
const FormFile = require('./components/FormFile');
const FormSelect = require('./components/FormSelect');
const FormNumber = require('./components/FormNumber');
const FormStatusWrapper = require('./components/FormStatusWrapper');
const IfResolved = require('./components/IfResolved');
const IfFailed = require('./components/IfFailed');
const IfSubmitting = require('./components/IfSubmitting');
const IfActive = require('./components/IfActive');
const RowBreak = require('./components/RowBreak');
const TextArea = require('./components/TextArea');

module.exports = {
  Form,
  FormField,
  FormCheckbox,
  FormSelect,
  FormNumber,
  FormButton,
  FormFile,
  FormStatusWrapper,
  IfResolved,
  IfFailed,
  IfSubmitting,
  IfActive,
  RowBreak,
  TextArea,
};
